<script setup lang="ts">
import SectionInstruction from '@sections/section-instruction.vue';
import { computed } from 'vue';
import {useI18n} from 'vue-i18n';

const { t, tm } = useI18n();
const header = {
	icon: '/images/instruction-icon.svg',
	title: t('instruction.title')
}
const list = computed(() => [
	{
		title: tm('instruction.list')[0].title,
		description: tm('instruction.list')[0].description,
		image: '/images/instructions/instruction-1.jpg',
		button: {
			title: tm('instruction.list')[0].button,
			to: '/settings/download_app/app',
		}
	},
	{
		title: tm('instruction.list')[1].title,
		description: tm('instruction.list')[1].description,
		image: '/images/instructions/instruction-2.jpg',
		button: {
			to: '/settings/setup_app/key',
			title:  tm('instruction.list')[1].button,
		}
	},
	{
		title: tm('instruction.list')[2].title,
		description: tm('instruction.list')[2].description,
		image: '/images/instructions/instruction-3.jpg'
	},
	{
		title: tm('instruction.list')[3].title,
		description: tm('instruction.list')[3].description,
		image: '/images/instructions/instruction-4.jpg'
	},
	{
		title: tm('instruction.list')[4].title,
		description: tm('instruction.list')[4].description,
		image: '/images/instructions/instruction-5.jpg'
	},
	{
		title: tm('instruction.list')[5].title,
		description: tm('instruction.list')[5].description,
		image: '/images/instructions/instruction-6.jpg'
	},
	{
		title: tm('instruction.list')[6].title,
		description: tm('instruction.list')[6].description,
		image: '/images/instructions/instruction-7.jpg'
	},
]);
</script>

<template>
	<main class="page page-instruction">
		<section-instruction
			:header="header"
			:list="list"
		/>
	</main>
</template>
